import { render } from "./AddFlatModal.vue?vue&type=template&id=1dda3260&scoped=true"
import script from "./AddFlatModal.vue?vue&type=script&lang=js"
export * from "./AddFlatModal.vue?vue&type=script&lang=js"

import "./AddFlatModal.vue?vue&type=style&index=0&id=1dda3260&lang=scss&scoped=true"

import exportComponent from "/home/prof1/projects/intercom_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dda3260"]])

export default __exports__